import type { SVGProps } from 'react';

const BRAND_FILLS = ['#E01E5A', '#36C5F0', '#2EB67D', '#ECB22E'] as const;

const PATHS = [
  'M27.2 80c0 7.3-5.9 13.2-13.2 13.2C6.7 93.2.8 87.3.8 80c0-7.3 5.9-13.2 13.2-13.2h13.2V80zm6.6 0c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V80z',
  'M47 27c-7.3 0-13.2-5.9-13.2-13.2C33.8 6.5 39.7.6 47 .6c7.3 0 13.2 5.9 13.2 13.2V27H47zm0 6.7c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H13.9C6.6 60.1.7 54.2.7 46.9c0-7.3 5.9-13.2 13.2-13.2H47z',
  'M99.9 46.9c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H99.9V46.9zm-6.6 0c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V13.8C66.9 6.5 72.8.6 80.1.6c7.3 0 13.2 5.9 13.2 13.2v33.1z',
  'M80.1 99.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V99.8h13.2zm0-6.6c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2h33.1c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H80.1z',
] as const;

export type SlackIconProps = SVGProps<SVGSVGElement> & {
  monochrome?: boolean;
  size?: number | string;
};

export const SlackIcon = ({
  monochrome = false,
  size = '1.5rem',
  'aria-hidden': ariaHidden = true,
  ...props
}: SlackIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 127 127"
    width={size}
    height={size}
    aria-hidden={ariaHidden}
    {...props}
  >
    {PATHS.map((d, index) => (
      <path
        key={d}
        d={d}
        fill={monochrome ? 'currentColor' : BRAND_FILLS[index]}
      />
    ))}
  </svg>
);
